import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_UPDATE_TABLE_SETTINGS_BEGIN,
  COLLECTIONS_UPDATE_TABLE_SETTINGS_SUCCESS,
  COLLECTIONS_UPDATE_TABLE_SETTINGS_FAILURE,
  COLLECTIONS_UPDATE_TABLE_SETTINGS_DISMISS_ERROR,
} from './constants';

export function updateTableSettings(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_TABLE_SETTINGS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/table-settings/${projectId}/col-settings`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_TABLE_SETTINGS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_TABLE_SETTINGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateTableSettingsError() {
  return {
    type: COLLECTIONS_UPDATE_TABLE_SETTINGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_TABLE_SETTINGS_BEGIN:
      return {
        ...state,
        updateTableSettingsPending: true,
        updateTableSettingsError: null,
      };

    case COLLECTIONS_UPDATE_TABLE_SETTINGS_SUCCESS:
      return {
        ...state,
        updateTableSettingsPending: false,
        updateTableSettingsError: null,
        tableSettings: action.data,
      };

    case COLLECTIONS_UPDATE_TABLE_SETTINGS_FAILURE:
      return {
        ...state,
        updateTableSettingsPending: false,
        updateTableSettingsError: action.data.error,
      };

    case COLLECTIONS_UPDATE_TABLE_SETTINGS_DISMISS_ERROR:
      return {
        ...state,
        updateTableSettingsError: null,
      };

    default:
      return state;
  }
}
